import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {

    TransactionDetailApplyList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/TransactionDetailApply/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    PostTransactionDetailApply({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/TransactionDetailApply/Post',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
}

const mutations = {
    
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transactionDetailApply.js